import { endExpiredSession } from './auth';

const API_BASE = '';

const sentAuthHeader = (options?: RequestInit): boolean => {
  const headers = options?.headers;
  if (!headers) return false;
  if (headers instanceof Headers) return headers.has('Authorization');
  if (Array.isArray(headers)) return headers.some(([k]) => k.toLowerCase() === 'authorization');
  return Object.keys(headers).some((k) => k.toLowerCase() === 'authorization');
};

/**
 * fetch() for the app's own API. If a logged-in request comes back 401 (the
 * login expired or is no longer valid), the user is sent to the login page
 * instead of the page silently showing empty lists. Requests without an auth
 * header (the login form itself, artist gallery links) are left alone, so a
 * wrong password or a closed review window still shows its normal message.
 */
export const apiFetch = async (path: string, options?: RequestInit): Promise<Response> => {
  const res = await fetch(API_BASE + path, options);
  if (res.status === 401 && sentAuthHeader(options)) endExpiredSession();
  return res;
};
